import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DEFAULT_NAVIGATION_EXTRAS } from '®shared/router/navigation-utils';

@Component({
  selector: 'rl-item-mode-resolver',
  template: '<rl-loader></rl-loader>',
})
export class ItemModeResolverComponent implements OnInit {
  constructor(private activatedRoute: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    this.router.navigate(['modes', 'view'], {
      ...DEFAULT_NAVIGATION_EXTRAS,
      relativeTo: this.activatedRoute,
    });
  }
}
